var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var pug_indent = [];
pug_html = pug_html + "\n\u003Cdiv class=\"title\" (dblclick)=\"hostWindow.toggleMaximize()\"\u003ETabby\u003C\u002Fdiv\u003E\n\u003Cwindow-controls *ngIf=\"!hideControls\"\u003E\u003C\u002Fwindow-controls\u003E";;return pug_html;};
module.exports = template;